export class ViajeVista {

    public idCompania: string;
    public idViaje: string;
    public idUsuario: string;
    public nombreUsuario: string;
    public idVehiculo: string;
    public totalPendientes: number;
    public totalVisitados: number;
    public totalAbortados: number;
    public tiempoPromedio: number;
    public tiempoPromedioVisita:number;
    
}